// Публичный подвал: реквизиты продавца, контакты, ссылки на документы и сведения об оплате (требования платёжных систем).
import React from 'react';
import { Link } from 'react-router-dom';
import { REQUISITES as R } from '../utils/requisites';
import { tt } from '../i18n';
import './styles/public-footer.css';

export default function PublicFooter() {
  return (
    <footer className="pfooter">
      <div className="pfooter-inner">
        <nav className="pfooter-links" aria-label={tt('Документы')}>
          <Link to="/public-offer">{tt('Публичная оферта')}</Link>
          <Link to="/privacy">{tt('Политика конфиденциальности')}</Link>
          <Link to="/refund">{tt('Возврат средств')}</Link>
          <Link to="/prohibited">{tt('Запрещённые товары')}</Link>
          <Link to="/terms">{tt('Условия')}</Link>
          <Link to="/contacts">{tt('Контакты')}</Link>
        </nav>
        <div className="pfooter-meta">
          <span>{R.owner}, {tt('ИИН')} {R.iin}</span>
          <span>{R.address}</span>
          <span>{tt('Тел.:')} <a href={`tel:+${R.phoneRaw}`}>{R.phone}</a></span>
          {R.email ? <span><a href={`mailto:${R.email}`}>{R.email}</a></span> : null}
        </div>
        <div className="pfooter-payrow">
          <span className="pfooter-logos" aria-label={tt('Принимаем к оплате')}>
            <span className="pfooter-logo"><img src="/pay-logos/visa.webp" alt="Visa" width="61" height="20" loading="lazy" /></span>
            <span className="pfooter-logo"><img src="/pay-logos/mastercard.webp" alt="Mastercard" width="26" height="20" loading="lazy" /></span>
          </span>
          <span className="pfooter-pay">{tt('Оплата банковскими картами Visa и Mastercard, Apple Pay и Google Pay через платёжный шлюз Freedom Pay. Мы не храним данные банковских карт.')}</span>
        </div>
      </div>
    </footer>
  );
}
